import { ErrorHandler, EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { scrubEvent } from './sentry-scrub.util';

const DSN = 'https://221da4a1fec4c5e5c986263bfc79a72e@o4510850311389184.ingest.de.sentry.io/4511960573542480';

/** Called from main.ts before bootstrap. The console runs in production only. */
export const initSentry = (): void => {
  Sentry.init({
    dsn: DSN,
    environment: 'production',
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend: scrubEvent,
  });
};

export const sentryProviders: (Provider | EnvironmentProviders)[] = [
  { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
  { provide: Sentry.TraceService, deps: [Router] },
  provideAppInitializer(() => {
    inject(Sentry.TraceService);
  }),
];
